import { UsuarioService } from "./../../../services/usuario/usuario.service";
import { SocketioService } from 'src/app/services/socketio.service';

import { Usuario } from "./../../../models/usuario";
import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MatDialogConfig,
  MatSlideToggle,
  MatSlideToggleChange,
} from "@angular/material";
import { CapturaComponent } from "../captura/captura.component";
import { InventariodialogComponent } from "../../inventariodialog/inventariodialog.component";
import { Empresa } from "src/app/models/empresa";
import { DOCUMENT } from "@angular/common";
import { EmpresaService } from "src/app/services/empresa.service";
import Swal from "sweetalert2";
import { ConfiguracionService } from "src/app/services/configuracion.service";
import { Dialogmensaje3botonesComponent } from "../../dialogmensaje3botones/dialogmensaje3botones.component";
import { createHash } from "crypto";

ConfiguracionService;

@Component({
  selector: "app-permisos",
  templateUrl: "./permisos.component.html",
  styleUrls: ["./permisos.component.css"],
})
export class PermisosComponent implements OnInit {
  modoMtto = false;
  @ViewChild("testSlider", { static: false }) t: MatSlideToggle;
  usuariolistado: Usuario[] = [];
  usuariosmx: Usuario[] = [];
  validacionchecada = false;
  chkservidorValor = false;
  tiposeleccion = false;
  statusvalidacion = "Desactivado";
  excelformatovalidado = false;
  countries = [
    { id: 1, name: "United States" },
    { id: 2, name: "USER_NONE" },
    { id: 3, name: "Canada" },
    { id: 4, name: "Brazil" },
    { id: 5, name: "England" },
  ];
  selectedValue = null;
  unsususuarios: any;

  constructor(
    public usuarioService: UsuarioService,
    public empresaService: EmpresaService,
    private dialog: MatDialog,
    @Inject(DOCUMENT) document,
    private configuracionService: ConfiguracionService,
    private socketService: SocketioService
  ) {}

  // ngOnDestroy() {
  //   this.unsususuarios.unsubscribe();
  // }

  ngOnInit() {

    const modomantenimiento = async ()=>{
      let modoto=   localStorage.getItem("servidormtto") ;
      this.modoMtto = Boolean(JSON.parse(modoto)); 
         
     }
    
     // aqui asignaremos otra color a lel logo de sportfishing y parpadeando
     modomantenimiento().then (()=>{
      this.chkservidorValor = this.modoMtto;
     })



    this.muestrausuariosmx();
    this.unsususuarios = this.usuariosptesAceptacion();
  }

  muestrausuariosmx() {
    this.usuarioService.listadototalusuariosmx().subscribe((resp) => {
      this.usuariosmx = resp.usuario;
    });
  }

  usuariosptesAceptacion() {
    this.usuarioService.listadototal().subscribe((resp) => {
      console.log("aqui", resp);
      this.usuariolistado = resp;
    });
  }

  // guardarusuarios(listadousuario: Usuario) {
  //    this.usuarioService.actualizaUsuarios(listadousuario)
  //    .subscribe();
  // }

  onCreate() {}

  usuariomxasignado(cveusuario: string) {
    let nombredelcliente = "";

    this.usuarioService.despliegausuario(cveusuario).subscribe((resp) => {
      nombredelcliente = resp.nombrecliente;
      return nombredelcliente;
    });
  }

  toggle(event: MatSlideToggleChange, listado: Usuario) {
   

    this.excelformatovalidado = event.checked;
   





    //esto es para configurar la ventana de dialogo
    const dialogConfig = new MatDialogConfig();

      dialogConfig.disableClose = true; // esta opcion inpide que la tecla esc desactive la ventana emergente
      dialogConfig.autoFocus = true;
      dialogConfig.width='500px';
     // dialogConfig.data= 'Sí desea realizar el cambio permanentemente presione  [ACEPTAR]? <br> Sí'    // esto es para trasnferir dtoa a dialog

    const dialogRef = this.dialog.open(Dialogmensaje3botonesComponent ,dialogConfig);
    dialogRef.afterClosed().subscribe((res) => {
  
      if (res =="permanente") {

        this.empresaService.modificastatusempresactivada(
          listado,
          listado._id,
          this.excelformatovalidado
        ).subscribe (respuesta =>{
          
    
          const payload = {
            valor: this.excelformatovalidado,
            idempresa: listado.idempresa['_id'],
            mensaje1: "Online",
            mensaje2:  "Offline",
            opcion : "permanente"
           
          };
          this.socketService.emit("validaormatoexcel", payload);
          
    
    
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Los cambios seran refrejados automaticamente',
            showConfirmButton: false,
            timer: 1500
          })
        });

      } else if (res =="temporal") {

        const payload = {
          valor: this.excelformatovalidado,
          idempresa: listado.idempresa['_id'],
          mensaje1: "Online",
          mensaje2:  "Offline",
          opcion : "temporal"
         
        };
        this.socketService.emit("validaormatoexcel", payload);
  
  
  
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Los cambios seran refrejados automaticamente, y por un solo evento',
          showConfirmButton: false,
          timer: 2000
        })
        
      };
    });







    
   








    
    // this.useDefault = event.checked;
  }

  muestrainventarios(listado: Usuario) {
    const dialogRef = this.dialog.open(InventariodialogComponent, {
      panelClass: "mensaje",
      disableClose: true,
      data: {
        identificador: listado,
      },
    });

    dialogRef.afterClosed().subscribe((data) => {
      this.unsususuarios = this.usuariosptesAceptacion();
    });
  }

  valorchanged(listado: any, id: Number) {
    if (this.tiposeleccion) {
      console.log("ACEPTADO", listado.idempresa.validaformato);
      console.log("ACEPTADO datos", listado);
    } else {
      console.log("NO ACEPTADO", listado.idempresa.validaformato);
    }
  }

  editarusuarios(listado: Usuario) {
    console.log("listado de datos", listado);
    const dialogRef = this.dialog.open(CapturaComponent, {
      panelClass: "mensaje",
      disableClose: true,
      data: {
        infousuariosmx: this.usuariosmx,
        identificador: listado,
      },
    });

    dialogRef.afterClosed().subscribe((data) => {
      this.unsususuarios = this.usuariosptesAceptacion();
    });
  }

  muestraLotes(listado: Usuario) {
    console.log("listado de datos", listado);
    const dialogRef = this.dialog.open(CapturaComponent, {
      panelClass: "mensaje",
      disableClose: true,
      data: {
        identificador: listado,
      },
    });

    dialogRef.afterClosed().subscribe((data) => {
      this.unsususuarios = this.usuariosptesAceptacion();
    });
  }

  toggleAll(events) {
    console.log("evento", events);
    console.log(events.target.checked);
    console.log("***", this.chkservidorValor);

    if (this.chkservidorValor == true) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Esta Seguro?",
          text: "Bloquear la aceptacion de solicitudes?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sí",
          cancelButtonText: "No, Cancelar!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            
            

            Swal.fire({
              title: "An input!",
              text: "Mensaje para los landing",
              input: 'text',
              showCancelButton: true        
          }).then((result) => {
              if (result.value) {
                var mensaje = String(result.value) ;
                  this.configuracionService
              .activamodo_mtto(this.chkservidorValor, mensaje)
              .subscribe((respuesta) => {



                localStorage.setItem(
                  "servidormtto",
                  'true'
                );

               
               
                
                const payload = {
                  valor: respuesta['statusMto'],
                  mensaje: mensaje
                 
                };
                this.socketService.emit("modomantenimiento", payload);



             //   alert("Archivos procesados");


              });
              }
          });





            
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire("Proceso Cancelado");
          }
        });
    } else {





      


      this.configuracionService
      .activamodo_mtto(this.chkservidorValor,"nada")
      .subscribe((respuesta) => { 
        
  localStorage.setItem(
                  "servidormtto",
                  "false"
                );
        
        const payload = {
          valor: respuesta['statusMto'],
         
        };
        this.socketService.emit("modomantenimiento", payload);




      });
    }
  }

  // statusmtto() {
  //   this.configuracionService
  //     .activamodo_mtto(this.chkservidorValor)
  //     .subscribe((respuesta) => {
  //       console.log("demostracion");
  //     });
  // }



  borrausuarios(listado: Usuario){


    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.empresaService.borraempresa(listado._id)
      }
    })



 








  
  }
}
